import { type AnyAction } from 'redux';
import { FETCH_LAST_FEATURED_POST_SUCCESS } from '../../common/actions/fetch-last-featured-post';
import { type NormalizedPost } from '../../common/types';

type LastFeaturedPostState = NormalizedPost | null;

const lastFeaturedPost = (
  state: LastFeaturedPostState = null,
  { type, payload }: AnyAction = {} as AnyAction,
): LastFeaturedPostState => {
  switch (type) {
    case FETCH_LAST_FEATURED_POST_SUCCESS:
      return payload || null;
    default:
      return state;
  }
};

export default lastFeaturedPost;
